(ns frontend.actions.screening-profile
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn *->get-all-screening-profiles
  [on-success! on-error!]
  (-> (conn/sendp! :screening-profile/get-all {})
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->submit-data-for-screening!
  [data on-success! on-error!]
  (-> (conn/sendp! :screening-profile/submit-data-for-screening
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->get-screening-profiles-for-kyc-profile
  [data on-success! on-error!]
  (-> (conn/sendp! :screening-profile/screening-profiles-for-kyc-profile
                   data)
      (p/then on-success!)
      (p/catch on-error!)))
